// src/utils/serviceUtils.js

// Flatten parent-child structure into a flat array
export const flattenServices = (services) => {
  const result = [];

  services.forEach((service) => {
    result.push({
      ...service,
      parentId: null,
    });

    if (service.children && service.children.length > 0) {
      service.children.forEach((child) => {
        result.push({
          ...child,
          parentId: service.serviceId,
        });
      });
    }
  });

  // Sort by serviceId ascending
  return result.sort((a, b) => a.serviceId - b.serviceId);
};

// Create a map for quick lookup
export const getServiceNameMap = (services) => {
  const map = {};
  services.forEach((service) => {
    map[service.serviceId] = service.serviceName;
    if (service.children && service.children.length > 0) {
      service.children.forEach((child) => {
        map[child.serviceId] = child.serviceName;
      });
    }
  });
  return map;
};

// Format camelCase or PascalCase to readable text
export const formatServiceName = (name) => {
  return name.replace(/([a-z])([A-Z])/g, "$1 $2");
};
